/**
 * Domain Statistics Detail Formatter.
 * @param {*} value
 * @param {*} row
 * @returns {*}
 */
window.domainStatisticsDetailFormatter = function(value, row) {
    let html = '';
    if (row.headers) {
        html += '<div class="form-group">';
        html += "<label>" + __("Request-Headers:") + "</label>";
        html += '<textarea class="form-control" rows="3">' + row.headers + "</textarea>";
        html += "</div>";
    }
    if (row.content) {
        html += '<div class="form-group">';
        html += "<label>" + __("Request-Content:") + "</label>";
        html += '<textarea class="form-control" rows="3">' + row.content + "</textarea>";
        html += "</div>";
    }
    return html;
};
